import { ErrorMessage, ErrorMessageProps } from '@design';
import { config } from '@terminal/config';
import clsx from 'clsx';
import React from 'react';
import { useTranslation } from 'react-i18next';

import styles from './BaseErrorView.module.scss';

interface BaseErrorViewProps extends ErrorMessageProps {
  className?: string;
  showBorder?: boolean;
}

export const BaseErrorView = ({
  className,
  title,
  subtitle,
  showBorder = false,
  ...rest
}: BaseErrorViewProps) => {
  const { t } = useTranslation(['common']);

  return (
    <div
      data-testid="base-error-view"
      className={clsx(styles.errorStateRoot, className, {
        [styles.showBorder]: showBorder,
      })}
    >
      <ErrorMessage
        className={styles.styledErrorMessage}
        displayIcon="error"
        title={title ?? t('common:error.title')}
        subtitle={
          subtitle ?? (
            <p className={styles.errorSubtitle}>
              {t('common:error.subtitle')}
              <a
                className={styles.emailLink}
                href={`mailto:${config.supportEmail}`}
              >
                {config.supportEmail}
              </a>
            </p>
          )
        }
        {...rest}
      />
    </div>
  );
};
